import {Column, HeaderProps} from 'react-table'
import {IInvoiceList} from '../core/_model'
import SelectionHeader from '../../../utils/components/table-content/SelectionHeader'
import {ListViewContext} from '../../../utils/contextProvider/ListViewProvider'
import {SelectionCell} from '../../../utils/components/table-content/SelectionCell'
import {PropsWithChildren} from 'react'
import {CustomHeader} from '../../../utils/components/table-content/CustomHeader'
import {formatDate} from '../../../utils/helperFunction/_helper'
import {KTIcon} from '../../../../_metronic/helpers'
import {Link} from 'react-router-dom'

const invoiceListColumn: ReadonlyArray<Column<IInvoiceList>> = [
  {
    Header: (props) => <SelectionHeader tableProps={props} context={ListViewContext} />,
    id: 'selection',
    Cell: ({...props}) => (
      <SelectionCell id={props.data[props.row.index].id} context={ListViewContext} />
    ),
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IInvoiceList>>) => (
      <CustomHeader tableProps={props} title='Username' className='min-w-100px' />
    ),
    id: 'user_full_name',
    accessor: 'user_full_name',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IInvoiceList>>) => (
      <CustomHeader tableProps={props} title='Invoice No' className='min-w-100px' />
    ),
    id: 'invoice_no',
    accessor: 'invoice_no',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IInvoiceList>>) => (
      <CustomHeader tableProps={props} title='Invoice Date' className='min-w-100px' />
    ),
    id: 'invoiceDate',
    Cell: ({...props}) => <>{formatDate(props.data[props.row.index].invoice_date)}</>,
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IInvoiceList>>) => (
      <CustomHeader tableProps={props} title='Type' className='min-w-100px' />
    ),
    id: 'type',
    accessor: 'type',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IInvoiceList>>) => (
      <CustomHeader tableProps={props} title='' className='min-w-100px' />
    ),
    id: 'action',
    Cell: ({...props}) => (
      <div className='text-end'>
        <Link
          to={`/billing/invoice/${props.data[props.row.index].id}`}
          className='btn btn-icon btn-sm btn-light'
        >
          <KTIcon iconName='eye' className='fs-2 text-info' />
        </Link>
      </div>
    ),
  },
]

export default invoiceListColumn
